/**
 * Side-effect module imported FIRST in main.ts so it runs before the kernel's
 * translation.config.ts reads `localStorage.getItem("language")` at top level.
 *
 * Seeds the user's language preference to Italian on first visit. Once the user
 * picks any language via the switcher, that choice persists and overrides this.
 */
const LANGUAGE_KEY = "language";
const DEFAULT_LANGUAGE = "it";

if (typeof localStorage !== "undefined" && !localStorage.getItem(LANGUAGE_KEY)) {
  localStorage.setItem(LANGUAGE_KEY, JSON.stringify(DEFAULT_LANGUAGE));
}
